export class ORGANIZATION_TYPE {
static readonly Practice:string = '00000044-1000-0000-0000-000000000001';
static readonly InsuranceCompany:string = '00000044-1000-0000-0000-000000000002';
static readonly MedicalSupplyVendor:string = '00000044-1000-0000-0000-000000000003';
static readonly OfficeSupplyVendor:string = '00000044-1000-0000-0000-000000000004';
static readonly InstrumentVendor:string = '00000044-1000-0000-0000-000000000005';
static readonly Pharmacy:string = '00000044-1000-0000-0000-000000000006';
static readonly PracticeDefaultFee:string = '00000044-1000-0000-0000-000000000007';
static readonly Enteprise:string = '00000044-1000-0000-0000-000000000008';
static readonly PraticeLocation:string = '00000044-1000-0000-0000-000000000009';
static readonly ReferringPractice:string = '00000044-1000-0000-0000-000000000011';
  }